import React from 'react';

import Metadata from '@pray/shared/components/Metadata';

import { CRM } from 'components/pages/public/components/icons/features';
import { PRODUCT_LABELS, Products } from 'components/pages/public/types/products';
import { VIEW_EVENT_NAMES } from 'constants.js';

import { Header } from '../../../../components/Header/Header';
import ProductPageLayout from '../../layout/ProductPageLayout';

const CustomerManagementPage: React.FC = () => {
  const ctaText = `TRY ${PRODUCT_LABELS[Products.PRAYSTUDIO]} ${PRODUCT_LABELS[Products.CRM]}`;
  return (
    <div data-viewname={VIEW_EVENT_NAMES.PRODUCTS.CRM}>
      <Metadata
        title={`${PRODUCT_LABELS[Products.CRM]} for Ministries: Grow Relationships Easily | ${
          PRODUCT_LABELS[Products.PRAYSTUDIO]
        }`}
        description={`Strengthen your ministry with ${PRODUCT_LABELS[Products.PRAYSTUDIO]}'s ${
          PRODUCT_LABELS[Products.CRM]
        }. Manage donors, members, & outreach effortlessly!`}
      />
      <Header />
      <ProductPageLayout
        // Hero section
        tag={PRODUCT_LABELS[Products.CRM]}
        icon={<CRM />} // Using CRM icon for Hero
        title="The first AI-powered CRM for Churches"
        description="Manage your church's relationships with ease."
        ctaText={ctaText}
        heroMedia={{ type: 'image', src: 'https://d339bgihw9yfmi.cloudfront.net/web/images/crm-hero.png' }}
        // No benefits section
        benefitsSectionTitle=""
        benefits={[]}
        // Mapping features to the 'steps' structure
        howItWorksSectionTitle=""
        steps={[
          {
            title: 'One Ministry Calendar for All Your Activities',
            description:
              'Manage marketing, content, social media, and communication all in one place. Plan ahead with ease, stay organized with drag-and-drop tools, and keep your congregation connected with consistent, inspired updates. Say goodbye to last-minute stress—start planning smarter today!',
            buttonText: ctaText,
            imageSrc: 'https://d339bgihw9yfmi.cloudfront.net/web/images/crm-benefit-step-4.png',
            imageAlt: 'Content Calendar',
          },
          {
            // No specific tag in image, using title
            title: 'Effortless Email Communication',
            description: `Craft professional email campaigns without requiring support from multiple stakeholders. Get started with one of ${
              PRODUCT_LABELS[Products.PRAYSTUDIO]
            }'s goal-based email templates that display perfectly across any device. Then use the drag-and-drop editor to customize layout, calls-to-action, and branding.`,
            buttonText: ctaText,
            imageSrc: 'https://d339bgihw9yfmi.cloudfront.net/web/images/crm-benefit-step-1.png',
            imageAlt: 'Effortless Email Communication',
          },
          {
            title: 'Keep Everyone in the Loop',
            description:
              "Posting announcements is a breeze! Share text, video, or audio updates directly to your congregation's feed. From daily reflections to sermon updates, keep everyone engaged and spiritually grounded no matter where they are.",
            buttonText: ctaText,
            imageSrc: 'https://d339bgihw9yfmi.cloudfront.net/web/images/crm-benefit-step-2.png',
            imageAlt: 'Keep Everyone in the Loop',
          },
          {
            title: 'Full-Featured Chat',
            description: `${
              PRODUCT_LABELS[Products.PRAYSTUDIO]
            } s direct messaging lets you connect individually with your followers—or allow them to reach out to you. These one-on-one moments make a big difference, helping you provide the guidance and encouragement they need.`,
            buttonText: ctaText,
            imageSrc: 'https://d339bgihw9yfmi.cloudfront.net/web/images/crm-benefit-step-3.png',
            imageAlt: 'Full-Featured Chat',
          },
          {
            title: 'Receive Testimonials',
            description: `Your ministry changes lives, and ${
              PRODUCT_LABELS[Products.PRAYSTUDIO]
            } makes it easier to gather the evidence of God's work through testimonials. Followers can share how your messages and prayers have impacted their lives, creating a cycle of encouragement and faith.`,
            buttonText: ctaText,
            imageSrc: 'https://d339bgihw9yfmi.cloudfront.net/web/images/crm-benefit-step-5.png',
            imageAlt: 'Receive Testimonials',
          },
        ]}
        // Solution cards section (using placeholders as before)
        solutionsSectionTitle="All-in-one Solution"
      />
    </div>
  );
};

export default CustomerManagementPage;
